function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 6.784L13.954.827a1.12 1.12 0 011.589 0c.436.44.436 1.153 0 1.593L8.797 9.17a1.123 1.123 0 01-1.551.033L.454 2.425c-.22-.22-.328-.51-.328-.797A1.12 1.12 0 012.043.831L8 6.784z",
  fill: "#4F4F4F"
});

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    fill: "none"
  }, props), _ref);
}

export default SvgArrowDown;